
import img1  from './drawings/image1.jpg'
import img2  from './drawings/image2.jpg'
import img3  from './drawings/image3.jpg'
import img4  from './drawings/image4.jpg'
import img5  from './drawings/image5.jpg'
import img6  from './drawings/image6.jpg'
import img7  from './drawings/image7.jpg'
import img8  from './drawings/image8.jpg'

import img10 from './drawings/image10.jpg'
import img11 from './drawings/image11.jpg'
import img12 from './drawings/image12.jpg'
import img13 from './drawings/image13.jpg'
import img14 from './drawings/image14.jpg'
import img15 from './drawings/image15.jpg'

 import imgTum1  from './drawings/imageTum1.jpg'
 import imgTum2  from './drawings/imageTum2.jpg'
 import imgTum3  from './drawings/imageTum3.jpg'
 import imgTum4  from './drawings/imageTum4.jpg'
 import imgTum5  from './drawings/imageTum5.jpg'
 import imgTum6  from './drawings/imageTum6.jpg'
 import imgTum7  from './drawings/imageTum7.jpg'
 import imgTum8  from './drawings/imageTum8.jpg'
 import imgTum10 from './drawings/imageTum10.jpg'
 import imgTum11 from './drawings/imageTum11.jpg'
 import imgTum12 from './drawings/imageTum12.jpg'
 import imgTum13 from './drawings/imageTum13.jpg'
 import imgTum14 from './drawings/imageTum14.jpg'
 import imgTum15 from './drawings/imageTum15.jpg'

const drawings = 
  [
    {
      src: img1,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum1
    },
    {
      src: img2,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 21x28cm',
      thumbnail : imgTum2
    },
    {
      src: img3,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum3
    },
    {
      src: img4,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum4
    },
    {
      src: img5,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum5
    },
    {
      src: img6,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum6
    },
    {
      src: img7,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum7
    },
    {
      src: img8,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum8
    },
  
    {
      src: img10,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum10
    },
    {
      src: img11,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum11
    },
    {
      src: img12,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum12
    },
    {
      src: img13,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum13
    },
    {
      src: img14,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum14
    },
    {
      src: img15,
      title: 'Untitled',
      description: 'Charcoal, pencile and ink on paper - 28x42cm',
      thumbnail : imgTum15
    },]

		export default drawings;